import { HttpInterceptorFn } from '@angular/common/http';

export const LanguageInterceptor: HttpInterceptorFn = (req, next) => {
  // Récupérer la langue actuelle de l'utilisateur
  const currentLang = localStorage.getItem('lang') ?? 'fr';
  // Cloner la requête et ajouter l'en-tête de langue
  const langReq = req.clone({
    setHeaders: {
      'Accept-Language': currentLang,
    },
  });

  // Ajout de log pour vérifier que l'en-tête est correctement ajouté
  // console.log('Adding language header:', currentLang);

  return next(langReq);
};
